import { useMemo } from 'react';

import { CoordinationClient, type CoordinationClientType } from '@atlassiansox/engagekit-ts';

export const useCoordinationClient = (
	cloudId: string,
	workspaceId?: string,
	orgId?: string,
): CoordinationClientType => {
	return useMemo(
		() =>
			new CoordinationClient({
				cloudId,
				stargateUrl: '/gateway/api',
				workspaceId,
				orgId,
				coordinationOptions: {
					/**
					 * This will prevent conflicting spotlights in products from displaying at the same time
					 */
					enableChoreographer: true,
				},
			}),
		[cloudId, workspaceId, orgId],
	);
};
